module.exports = __webpack_public_path__ + "static/media/excalidraw_obsidian_logo.c8c1fdab.svg";